import useAuth from "@/library/auth/_hook.auth"
import React, {FormEvent, useEffect, useState} from "react"
import {useNavigate} from "@tanstack/react-router"
import {Credentials} from "@/library/api/models/auth"
import useToasts from "@/library/toasts/_hook.toast"
import ToastsList from "@/components/ui-kit/toasts-list"
import Button from "@/components/ui-kit/button"
import FormSection from "@/components/forms/form-design/form-section"
import InputGroup from "@/components/forms/form-design/input-group"

export default function SignInPage() {
    const {isLoading, token, login} = useAuth()
    const {toast, clear} = useToasts()
    const navigate = useNavigate({from: "/auth/sign-in"})

    const [credentials, setCredentials] = useState<Credentials>({
        email: "",
        password: "",
    })

    useEffect(() => {
        if (!isLoading && token)
            navigate({to: "/portal"}).then()
    }, [isLoading, navigate, token])

    const submitLogin = (e: FormEvent) => {
        e.preventDefault()

        login(credentials)
            .catch(err => {
                clear()

                toast('login-error', {
                    category: "login",
                    type: 'error',
                    title: 'Innlogging feilet',
                    canDismiss: true,
                    autoClose: false,
                    message: err
                })
            })
    }

    return <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100svh"
    }}>

        <div style={{
            display: "flex",
            flexFlow: "column",
            //gap: "1rem",
            //width: "100%",
            //maxWidth: "500px",
            //height: "min-content",
            background: "#fff",
            padding: "1rem",
            borderRadius: "var(--border-radius)",
        }}>
            <form onSubmit={submitLogin}>
                    <h2>Logg inn</h2>

                    <ToastsList category="login"/>

                    <FormSection>
                        <InputGroup
                            label="E-post"
                            inputElement={
                                <input placeholder="email@address.com"
                                       autoComplete="email"
                                       type="email"
                                       name="email"
                                       value={credentials.email}
                                       onChange={e => setCredentials(current => {
                                           return {
                                               ...current,
                                               email: e.target.value
                                           }
                                       })}
                                />
                            }
                        />
                        <InputGroup
                            label="Passord"
                            inputElement={
                                <input autoComplete="current-password"
                                       placeholder="Your password..."
                                       type="password"
                                       name="password"
                                       value={credentials.password}
                                       onChange={e => setCredentials(current => {
                                           return {
                                               ...current,
                                               password: e.target.value
                                           }
                                       })}
                                />
                            }
                        />
                        <Button type="submit" color="primary">Logg inn</Button>
                        <Button color="default" disabled>Glemt passord</Button>
                    </FormSection>
            </form>
        </div>
    </div>
}
